module.exports = "/images/mx.svg?e5ea674dc3335991d7820cc3489500d9";